import { get,postP,put } from '@/utils/axios'

export default {
    
    // 管理登录
    signIn(datas){
        return get('OAuth/SignInAsync',datas)
    },
    // 车险用户登录
    carSinInAsync(datas){
        return get('OAuth/CarSinInAsync',datas)
    },
    // 修改密码
    updatePassword(datas){
        return put('OAuth/updatePassword',datas)
    },
}